import { RemoteType } from '../types';
import { get } from '../utils';
import { Dispatch, UnknownAction } from 'redux';

const UPDATE = 'UPDATE_ACTION';

interface TypesAction extends UnknownAction {
  types: RemoteType[];
}

export function typesReducer(types: RemoteType[] = [], action: TypesAction): RemoteType[] {
  if (action.type === UPDATE) {
    return action.types;
  }
  return types;
}

export function fetchTypesAction(dispatch: Dispatch): void {
  get<RemoteType[]>('/aktiviteter/api/types')
    .then((types) => {
      dispatch({ type: UPDATE, types });
    })
    .catch(function (ex) {
      console.error('Failed to fetch types', ex);
    });
}
